import React from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import NumberInput from 'material-ui-number-input';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';

import moment from 'moment';

import utils from './../misc/utils';

const Styles = {
  checkBox: {
    marginTop: 5,
    marginBottom: 5
  },
  selectField: {
    backgroundColor: 'white'
  }
};

class EntityEdit extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.fetchSchema = this.fetchSchema.bind(this);
    this.fetchSelectListItems = this.fetchSelectListItems.bind(this);
    this.onSelectControlExpand = this.onSelectControlExpand.bind(this);
    this.getItemDisplayValue = this.getItemDisplayValue.bind(this);
    this.initSelectFieldsDataSources = this.initSelectFieldsDataSources.bind(this);
    this.setEntityValue = this.setEntityValue.bind(this);
    this.handleTextFieldChanged = this.handleTextFieldChanged.bind(this);
    this.handleSelectFieldChanged = this.handleSelectFieldChanged.bind(this);
    this.handleCheckboxChanged = this.handleCheckboxChanged.bind(this);
    this.handleIntegerFieldChanged = this.handleIntegerFieldChanged.bind(this);
    this.handleNumericFieldChanged = this.handleNumericFieldChanged.bind(this);
    this.handleDateChanged = this.handleDateChanged.bind(this);
    this.getComponentFromFieldDef = this.getComponentFromFieldDef.bind(this);

    this.state = {
      fields: [],
      selectFieldDataSources: {},
      currentEntity: props.entity,
      isNew: (Object.keys(props.entity).length === 0)
    }
  }

  fetchSchema(){
    utils.getDataFromApi(this.props.apiRoute + '/schema', (results) => {
      var resultFields = results.properties;
      this.initSelectFieldsDataSources(resultFields);
      this.setState({
        fields: resultFields
      });
    }, null);
  }

  fetchSelectListItems(required, apiRoute, fieldName, displayFields){
    utils.getDataFromApi(apiRoute, (results) => {
      var controls = results.map((item) => {
        var displayValue = this.getItemDisplayValue(item, displayFields);
        return (<MenuItem key={item.ID} value={item.ID} primaryText={displayValue} />);
      });
      if(!required)
        controls.unshift((<MenuItem key={null} value={null} primaryText={' '} />));

      var currentSelectFieldDataSources = this.state.selectFieldDataSources;
      currentSelectFieldDataSources[fieldName] = {loaded: true, dataSource: controls};
      this.setState({selectFieldDataSources : currentSelectFieldDataSources});
    }, null);
  }

  onSelectControlExpand(event, required, apiRoute, fieldName, displayFields){
    if(!(fieldName in this.state.selectFieldDataSources) || !this.state.selectFieldDataSources[fieldName].loaded){
      this.fetchSelectListItems(required, apiRoute, fieldName, displayFields);
    }
  }

  initSelectFieldsDataSources(fields){
    var context = this;
    var currentSelectFieldDataSources = this.state.selectFieldDataSources;
    Object.keys(fields).map(function(fieldName) {
      var fieldDef = fields[fieldName];
      if(fieldDef.type === 'integer' && fieldDef.belongsTo && (!currentSelectFieldDataSources[fieldName] || !currentSelectFieldDataSources[fieldName].loaded)){
        if(fieldDef.associatedColumn && context.state.currentEntity[fieldDef.associatedColumn]){
          var currentItem = context.state.currentEntity[fieldDef.associatedColumn];
          var displayValue = context.getItemDisplayValue(currentItem, fieldDef.displayFields);
          var currentItemControl = (<MenuItem key={currentItem.ID} value={currentItem.ID} primaryText={displayValue} />);

          currentSelectFieldDataSources[fieldName] = {loaded: false, dataSource: [currentItemControl]};
        }
        else
          currentSelectFieldDataSources[fieldName] = {loaded: false, dataSource: []};
      }
    });

    this.setState({selectFieldDataSources : currentSelectFieldDataSources});
  }

  getItemDisplayValue(item, displayFields){
    var displayValue = '';
    for(var i = 0; i < displayFields.length; i++){
      var displayField = displayFields[i];
      if(displayValue !== '')
        displayValue += '|';

      displayValue += item[displayField];
    }
    return displayValue;
  }

  handleTextFieldChanged(fieldName, e){
    if(e.target.value === '')
      this.setEntityValue(fieldName, null);
    else
      this.setEntityValue(fieldName, e.target.value);
  }

  handleIntegerFieldChanged(fieldName, e){
    if(Number(e.target.value) === parseInt(e.target.value, 10))
      this.setEntityValue(fieldName, Number(e.target.value));
    else if(!e.target.value)
      this.setEntityValue(fieldName, null);
  }

  handleNumericFieldChanged(fieldName, e){
    if(e.target.value === '')
      this.setEntityValue(fieldName, null);
    else
      this.setEntityValue(fieldName, e.target.value);
  }

  handleSelectFieldChanged(fieldName, e, key, payload){
    var fieldDef = this.state.fields[fieldName];
    if(fieldDef.associatedColumn){
      var entity = this.state.currentEntity;

      if(!entity[fieldDef.associatedColumn])
        entity[fieldDef.associatedColumn] = {};
      entity[fieldDef.associatedColumn].ID = payload;
    }
    this.setEntityValue(fieldName, payload);
  }

  handleCheckboxChanged(fieldName, e, isInputChecked){
    this.setEntityValue(fieldName, isInputChecked);
  }

  handleDateChanged(fieldName, e, date){
    this.setEntityValue(fieldName, moment(date.toString()).format('YYYYMMDD'));
  }

  setEntityValue(fieldName, value){
    var entity = this.state.currentEntity;
    entity[fieldName] = value;
    this.setState({currentEntity: entity});
  }

  componentDidMount(){
    this.fetchSchema();
  }

  getComponentFromFieldDef(fieldName, fieldDef, customWidth, customLabel, controlOptions){
    if(fieldName && fieldDef){
      var control = null;
      var value = null;
      if(this.state && this.state.currentEntity)
        value = this.state.currentEntity[fieldName];

      var styleWidth = {};
      if(customWidth)
        styleWidth.width = customWidth;

      switch(fieldDef.type){
        case 'string':
          control = (
            <TextField
              ref={fieldName}
              errorText={(fieldDef.required && (!value || value === '')) && 'Ce champ est requis'}
              floatingLabelText={(customLabel ? customLabel : fieldDef.displayText)}
              style={styleWidth}
              maxLength={fieldDef.length}
              multiLine={((fieldDef.length === '' || fieldDef.length > 500) ? true : false)}
              fullWidth={((fieldDef.length === '' || fieldDef.length > 500) ? true : false)}
              onChange={(event) => this.handleTextFieldChanged(fieldName, event)}
              value={value ? value : ''}
              {...controlOptions} />
          );
        break;
        case 'boolean':
          control = (
            <Checkbox
              ref={fieldName}
              style={Styles.checkBox}
              label={fieldDef.displayText}
              onCheck={(event, isInputChecked) => this.handleCheckboxChanged(fieldName, event, isInputChecked)}
              checked={value ? value : false}/>
          );
        break;
        case 'integer':
          if(fieldDef.belongsTo){
            control = (
              <SelectField
                ref={fieldName}
                menuStyle={Styles.selectField}
                errorText={(fieldDef.required && (!value || value === 0)) && 'Ce champ est requis'}
                floatingLabelText={(customLabel ? customLabel : fieldDef.displayText)}
                style={styleWidth}
                children={this.state.selectFieldDataSources[fieldName].dataSource}
                onTouchTap={(event) => this.onSelectControlExpand(event, fieldDef.required, fieldDef.route, fieldName, fieldDef.displayFields)}
                value={value}
                onChange={(event, key, payload) => this.handleSelectFieldChanged(fieldName, event, key, payload)}
                maxHeight={200}/>
            );
          }
          else{
            control = (
              <TextField
                ref={fieldName}
                errorText={(fieldDef.required && !value) && 'Ce champ est requis'}
                floatingLabelText={(customLabel ? customLabel : fieldDef.displayText)}
                style={styleWidth}
                type='number'
                onChange={(event) => this.handleIntegerFieldChanged(fieldName, event)}
                value={value ? value.toString() : ''} />
            );
          }
        break;
        case 'date':
          if(value && value.length > 10)
            value = new Date(value).toISOString().slice(0,10).replace('-', '').replace('-', '');

          control = (
            <DatePicker
              ref={fieldName}
              floatingLabelText={(customLabel ? customLabel : fieldDef.displayText)}
              style={styleWidth}
              container='inline'
              autoOk={true}
              onChange={(event, date) => this.handleDateChanged(fieldName, event, date)}
              value={value ? moment(value)._d : ''}/>
          );
        break;
        case 'number':
          control = (
            <TextField
              ref={fieldName}
              errorText={(fieldDef.required && !value) && 'Ce champ est requis'}
              floatingLabelText={(customLabel ? customLabel : fieldDef.displayText)}
              style={styleWidth}
              type='number'
              onChange={(event) => this.handleNumericFieldChanged(fieldName, event)}
              value={value ? value.toString() : ''} />
          );
        break;
      }

      return control;
    }
    else
      return null;
  }

  render(){
    var fields = this.state.fields;
    var context = this;
    var fieldsControls = Object.keys(fields).map(function(fieldName) {
      if(fieldName !== 'ID'){
        var fieldDef = fields[fieldName];
        return (<div key={fieldName}>{context.getComponentFromFieldDef(fieldName, fieldDef)}</div>);
      }
    });

    return (
      <div>
        {fieldsControls}
      </div>
    );
  }
}

export default EntityEdit;



/** WEBPACK FOOTER **
 ** ./src/app/components/entityEdit.js
 **/